import {
	GetProvidersMedicalGuideModelV3,
	GetProvidersMedicalGuideParamsV3,
} from 'domain/usecases/private/guide-flow/medical-guide/get-providers-v3';
import {makeGetProvidersMedicalGuideV3} from 'main/factories/usecases/private/guide-flow/remote-medical-guide/get-providers-factory-v3';

export async function getHealthProvidersV3(
	params: GetProvidersMedicalGuideParamsV3,
): Promise<GetProvidersMedicalGuideModelV3> {
	const {
		coordenadas,
		cdUf,
		nmCidade,
		dsEspecialidade,
		cd_procedimento,
		distancia,
		firstNetworkType,
		tpRede,
		nmPrestador,
		...rest
	} = params;

	const locationParams = coordenadas ? {coordenadas} : {cdUf, nmCidade};

	const response = await makeGetProvidersMedicalGuideV3().get({
		...locationParams,
		...(firstNetworkType !== undefined && {firstNetworkType}),
		...(tpRede !== undefined && {tpRede}),
		...(cd_procedimento !== undefined && {cd_procedimento}),
		...(nmPrestador !== undefined && {nmPrestador}),
		dsEspecialidade: dsEspecialidade ?? '',
		distancia: distancia ?? '25',
		...rest,
	});

	if (!response) {
		return {
			prestadores: [],
			pageNumber: params.page ?? 1,
			limit: params.limit ?? 10,
			hasNextPage: false,
		};
	}

	return response;
}
